import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FemaleDisordersPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Female Disorders</h1>
        <section className="mb-8">
          <p>Female disorders encompass various conditions affecting women's reproductive and hormonal health, including menstrual irregularities, PCOS, and hormonal imbalances. Our natural therapies focus on restoring hormonal balance and supporting overall reproductive health.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Common Conditions</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Menstrual irregularities</li>
            <li>PCOS (Polycystic Ovary Syndrome)</li>
            <li>Hormonal imbalances</li>
            <li>Menopausal symptoms</li>
            <li>Reproductive health issues</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Irregular menstrual cycles</li>
            <li>Hormonal fluctuations</li>
            <li>Mood changes</li>
            <li>Physical discomfort</li>
            <li>Fertility concerns</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use hormone-balancing herbs, lifestyle modifications, and holistic therapies to address the root cause of female disorders. Each treatment plan is personalized to support your unique hormonal needs and reproductive health goals.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Balances hormones naturally</li>
            <li>Supports reproductive health</li>
            <li>No harsh side effects</li>
            <li>Personalized care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a balanced diet</li>
            <li>Regular exercise</li>
            <li>Stress management</li>
            <li>Regular health check-ups</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment help with PCOS?</strong>
            <p>A: Yes, our approach can help manage PCOS symptoms and support hormonal balance.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe during pregnancy?</strong>
            <p>A: We provide specialized care for pregnant women, focusing on safe, gentle remedies.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see improvement?</strong>
            <p>A: Many patients notice positive changes within a few months of treatment.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Support your health—book your natural female health consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default FemaleDisordersPage; 